import { createPortal } from "react-dom";
import { CalendarOff, Loader2 } from "lucide-react";

export default function CompOffGrantDialog({
  dayKind = "week off",
  holidayName = "",
  dateLabel = "",
  employeeName = "this employee",
  creditLabel = "1 day",
  busy = false,
  onAllow,
  onSkip,
  onCancel,
}) {
  const kindLabel = dayKind === "holiday"
    ? `holiday${holidayName ? ` (${holidayName})` : ""}`
    : "week off";

  return createPortal(
    <div
      className="fixed inset-0 z-[10000] flex items-center justify-center bg-black/50 px-4"
      onClick={(e) => {
        if (e.target === e.currentTarget && !busy) onCancel();
      }}
    >
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden">
        <div className="px-5 py-4 bg-gradient-to-r from-amber-50 to-orange-50 border-b border-amber-100">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-xl bg-amber-500 text-white flex items-center justify-center shrink-0">
              <CalendarOff size={18} />
            </div>
            <div>
              <h3 className="text-base font-bold text-slate-900">Add this day as Comp Off?</h3>
              <p className="text-sm text-slate-600 mt-0.5">{dateLabel}</p>
            </div>
          </div>
        </div>
        <div className="px-5 py-4">
          <p className="text-sm text-slate-700 leading-relaxed">
            {dateLabel ? `${dateLabel} is` : "This day is"} currently a {kindLabel} for this
            organisation. You are changing it to a working day for <span className="font-semibold">{employeeName}</span>.
            If you allow Comp Off, {creditLabel} will be added to this employee&apos;s Comp Off balance.
          </p>
        </div>
        <div className="flex flex-col-reverse sm:flex-row sm:justify-end gap-2 px-5 py-3 border-t border-slate-100 bg-slate-50/70">
          <button
            type="button"
            onClick={onCancel}
            disabled={busy}
            className="px-4 py-2 rounded-xl text-sm font-semibold text-slate-700 border border-slate-300 hover:bg-white disabled:opacity-50"
          >
            Go back
          </button>
          <button
            type="button"
            onClick={onSkip}
            disabled={busy}
            className="px-4 py-2 rounded-xl text-sm font-semibold text-slate-800 border border-slate-300 bg-white hover:bg-slate-50 disabled:opacity-50"
          >
            Save without Comp Off
          </button>
          <button
            type="button"
            onClick={onAllow}
            disabled={busy}
            className="px-4 py-2 rounded-xl text-sm font-bold text-white bg-amber-600 hover:bg-amber-700 disabled:opacity-70 inline-flex items-center justify-center gap-2"
          >
            {busy ? <Loader2 size={14} className="animate-spin" /> : null}
            Allow Comp Off
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
}
